export default __webpack_public_path__ + "static/media/phases_pre_contruction.d762a575.webp";